export const ChatInput = {
  flow: 'x',
  gap: 'Y',
  padding: 'Z A',
  borderTop: '1px solid inkBorder',
  background: 'inkMid',
  align: 'center flex-start',

  MessageField: {
    extends: 'Input',
    placeholder: '{{ typeAMessage | polyglot }}',
    flex: '1',
    padding: 'Z A',
    round: 'Z',
    background: 'inkSurface',
    border: '1px solid inkBorder',
    color: 'inkText',
    fontSize: 'Z',
    onKeypress: (e, el, s) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
      }
    }
  },

  SendBtn: {
    extends: 'Button',
    text: '{{ send | polyglot }}',
    padding: 'Z A',
    round: 'Z',
    background: 'teal',
    color: 'white',
    fontWeight: '600',
    fontSize: 'Z',
    cursor: 'pointer',
    flexShrink: '0',
    border: 'none',
    transition: 'opacity 150ms ease',
    ':hover': { opacity: '0.85' }
  }
}
